(() => {
    const $videoModal = document.querySelector('.video-modal');
    const $videoModalVideo = document.querySelector('.video-modal__video');

    if ($videoModal) {
        $videoModal.addEventListener('modalopen', e => {
            $videoModalVideo.src = $videoModalVideo.dataset.src;
        });

        $videoModal.addEventListener('modalafterclose', e => {
            $videoModalVideo.src = '';
        });
    }
})();
